import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {VisitConfigurationModel} from "../../../models/visit-configuration.model";

require('./visit-configurations-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-visit-configurations-table-row',
  templateUrl: './visit-configurations-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitConfigurationsTableRowComponent {

  @Input() visitConfiguration: VisitConfigurationModel;
  @Input() showAccountColumn?: boolean;
  @Input() isSelected: boolean;

  @Output() onToggle = new EventEmitter<boolean>();
  @Output() onEdit = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
}
